package com.taocent.simple.compose.component.blockrichtext.internal.registry

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.taocent.simple.compose.component.blockrichtext.DocumentBlock
import kotlin.reflect.KClass

interface BlockRenderer<T : DocumentBlock> {

    val kind: BlockKind

    val blockClass: KClass<@UnsafeVariance T>

    @Composable
    fun Render(
        block: T,
        blockState: com.taocent.simple.compose.component.blockrichtext.BlockState,
        modifier: Modifier
    )

    @Suppress("UNCHECKED_CAST")
    @Composable
    fun renderAny(
        block: DocumentBlock,
        blockState: com.taocent.simple.compose.component.blockrichtext.BlockState,
        modifier: Modifier
    ) {
        Render(block as T, blockState, modifier)
    }
}
